export function jsonParseOrUndefined<T extends any>(
  valueToDecode: string
): T | undefined {
  try {
    // This is the only place in the project where JSON.parse is allowed
    // eslint-disable-next-line no-restricted-properties
    return JSON.parse(valueToDecode);
  } catch (e) {
    console.error("Failed to decode JSON string", e);
    return undefined;
  }
}
